import React from 'react';
import { Badge, Box, Text } from '@wix/design-system';
import { RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { useIsMobile } from '../../hooks/useIsMobile';
import s from './MatchLabelBadge.css';
const labelTranslationKey = {
  [RecommendationLabel.EXACT_MATCH]: 'domain_search_suite.domain_suggestions.badge.exact_match',
  [RecommendationLabel.BEST_MATCH]: 'domain_search_suite.domain_suggestions.badge.best_match',
  [RecommendationLabel.GREAT_ALTERNATIVE]: 'domain_search_suite.domain_suggestions.badge.great_alternative'
};
export const hasMatchLabel = label => label !== undefined && label !== RecommendationLabel.UNKNOWN_LABEL && Boolean(labelTranslationKey[label]);
export const MatchLabelBadge = _ref => {
  let label = _ref.label,
    _ref$optimized = _ref.optimized,
    optimized = _ref$optimized === void 0 ? false : _ref$optimized,
    _ref$primary = _ref.primary,
    primary = _ref$primary === void 0 ? false : _ref$primary,
    className = _ref.className;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  const isMobile = useIsMobile();
  const size = isMobile ? 'tiny' : 'small';
  const key = label === 'RECOMMENDED' ? 'domains_search_suite.anon_storefront_results.optimizations.container.double_taken.badge' : labelTranslationKey[label];
  if (!key) {
    return null;
  }
  const defaultClassName = optimized && !primary ? s.MatchBadgeOptimizedAlt : s.MatchBadge;
  const badge = /*#__PURE__*/React.createElement(Badge, {
    skin: "premium",
    size: size,
    uppercase: false,
    className: className ? undefined : defaultClassName
  }, /*#__PURE__*/React.createElement(Text, {
    size: size,
    weight: "normal",
    light: true
  }, t(key)));
  return className ? /*#__PURE__*/React.createElement(Box, {
    className: className
  }, badge) : badge;
};
//# sourceMappingURL=MatchLabelBadge.js.map